
import { useEffect, useState } from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2
} from "variables/charts.js";

import Header from "components/Headers/Header.js";
import { useAccount } from "flow/flowContext";
import { useFcl } from "flow/flowContext";

import { getAuthAccount, getPublicAccount, iterateOnStoragePaths } from "flow/scripts/account.js";

import { addKeyToAccount } from "flow/transactions/account";
import { revokeKeyFromAccount } from "flow/transactions/account";
import { iterateOnPublicPaths } from "flow/scripts/account";
import { iterateOnPrivatePaths } from "flow/scripts/account";
import { sendCapability } from "flow/transactions/account";
import { getAccountData } from "flow/scripts/account";

const Index = (props) => {
  const [activeNav, setActiveNav] = useState(1);
  const [chartExample1Data, setChartExample1Data] = useState("data1");

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const toggleNavs = (e, index) => {
    e.preventDefault();
    setActiveNav(index);
    setChartExample1Data("data" + index);
  };

  // FLow Data Query 
  const { address, isConnected, disconnect, connect } = useAccount();
  const [accountData, setAccountData] = useState(null);


  const fetchAccountData = async () =>{
    const accountData = await getAccountData(address)
    setAccountData(accountData)
  }

  useEffect(() => {
    fetchAccountData()
  }, [])



  return (
    <>
      <Header accountData={accountData}/>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* <Row>
          <Col className="mb-5 mb-xl-0" xl="8">
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-light ls-1 mb-1">
                      Overview
                    </h6>
                    <h2 className="text-white mb-0">Sales value</h2>
                  </div>
                  <div className="col">
                    <Nav className="justify-content-end" pills>
                      <NavItem>
                        <NavLink
                          className={classnames("py-2 px-3", {
                            active: activeNav === 1
                          })}
                          href="#pablo"
                          onClick={(e) => toggleNavs(e, 1)}
                        >
                          <span className="d-none d-md-block">Month</span>
                          <span className="d-md-none">M</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames("py-2 px-3", {
                            active: activeNav === 2
                          })}
                          data-toggle="tab"
                          href="#pablo"
                          onClick={(e) => toggleNavs(e, 2)}
                        >
                          <span className="d-none d-md-block">Week</span>
                          <span className="d-md-none">W</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </Row>
              </CardHeader>
              <CardBody> */}
                {/* Chart */}
                {/* <div className="chart">
                  <Line
                    data={chartExample1[chartExample1Data]}
                    options={chartExample1.options}
                    getDatasetAtEvent={(e) => console.log(e)}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      Performance
                    </h6>
                    <h2 className="mb-0">Total orders</h2>
                  </div>
                </Row>
              </CardHeader>
              <CardBody> */}
                {/* Chart */}
                {/* <div className="chart">
                  <Bar
                    data={chartExample2.data}
                    options={chartExample2.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row> */}
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="4">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Active Keys</h3>
                  </div>
                  <div className="col text-right">
                    <Link to= "/admin/keys-manager">
                    <Button
                      color="primary"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      More
                    </Button>
                    </Link>
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Publick key</th>
                    <th scope="col">weight</th>
                    <th scope="col">type</th>
                  </tr>
                </thead>
                <tbody>
                 
                    {accountData && accountData.keys.activeKeys.map((key) =>{
                      return(
                        <>
                        <tr>
                        <th scope="row">{key.publicKey.substring(0,10)}...{key.publicKey.substring(key.publicKey.length-10)}</th>
                        <td>{key.weight}</td>
                        <td>{key.signAlgoString}</td>
                        </tr>
                        </>
                      )
                    })}
                  
                </tbody>
              </Table>
            </Card>
          </Col>
          <Col xl="4" className="mb-5 mb-xl-0">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Contracts</h3>
                  </div>
                  <div className="col text-right">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      More
                    </Button>
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Contract Name</th>
                    <th scope="col">Size</th>
                    {/* <th scope="col" /> */}
                  </tr>
                </thead>
                <tbody>

                {accountData && accountData.contracts.map((contract) =>{
                      return(
                        <>
                        <tr>
                        <th scope="row">{contract.name}</th>
                        <td>{new Blob([contract.code]).size/1024} &nbsp; KB</td>
                        </tr>
                        </>
                      )
                    })}                 
                </tbody>
              </Table>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Storage</h3>
                  </div>
                  <div className="col text-right">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      More
                    </Button>
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Elements</th>
                    {/* <th scope="col">Size</th> */}
                    {/* <th scope="col" /> */}
                  </tr>
                </thead>
                <tbody>

                {accountData && accountData.storagePaths.map((storage) =>{
                      return(
                        <>
                        <tr>
                        <th scope="row">{storage.identifier}</th>
                        </tr>
                        </>
                      )
                    })}                 
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Index;
